import { IOption } from "@faire/web--source/slate/Dropdown";

import { USER_TYPE } from "../types";

import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { useLoggedOutBrandNodes } from "./useLoggedOutBrandNodes";
import {
  useLoggedOutBrandNodesL1,
  useLoggedOutBrandNodesL2,
  useLoggedOutBrandNodesL3BySoyo,
  useLoggedOutBrandNodesL3BySwf,
} from "./useLoggedOutBrandNodesOption";
import { useLoggedOutRetailerNodes } from "./useLoggedOutRetailerNodes";
import {
  useLoggedOutRetailerNodesL1,
  useLoggedOutRetailerNodesL2,
} from "./useLoggedOutRetailerNodesOption";

export const useLoggedOutIssuesDropdown = () => {
  const [
    { issueL1, issueL2, issueL3, user },
    setLoggedOutContactUsContextStore,
  ] = useLoggedOutContactUsContextStore([
    "issueL1",
    "issueL2",
    "issueL3",
    "user",
    "currentStep",
  ]);
  const brandNodes = useLoggedOutBrandNodes();
  const brandNodesL1 = useLoggedOutBrandNodesL1();
  const brandNodesL2 = useLoggedOutBrandNodesL2();
  const retailerNodes = useLoggedOutRetailerNodes();
  const retailerNodesL1 = useLoggedOutRetailerNodesL1();
  const retailerNodesL2 = useLoggedOutRetailerNodesL2();
  const brandNodesL3BySWF = useLoggedOutBrandNodesL3BySwf();
  const brandNodesL3BySOYO = useLoggedOutBrandNodesL3BySoyo();

  const isRetailer = user === "retailer";

  const issuesFromL1 = isRetailer ? retailerNodesL1 : brandNodesL1;

  const issuesFromL2 = isRetailer ? retailerNodesL2 : brandNodesL2;

  const showGoToOrderPageCopy =
    issueL1 === retailerNodes.L1.Items || issueL1 === retailerNodes.L1.Returns;

  const issuesFromL3 = (): IOption[] => {
    switch (issueL2) {
      case brandNodes.L2.SWF:
        return brandNodesL3BySWF;
      case brandNodes.L2.SOYO:
        return brandNodesL3BySOYO;
      default:
        return [];
    }
  };

  const handleUserDropdown = (option: IOption) => {
    setLoggedOutContactUsContextStore({
      user: option.value as USER_TYPE,
      issueL1: "",
      issueL2: "",
      issueL3: "",
    });
  };

  const showDropdownL2 = (): boolean => {
    if (isRetailer) {
      return issueL1 === retailerNodes.L1.GeneralShipping;
    }
    return issueL1 === brandNodes.L1.GeneralShipping;
  };

  const showDropdownL3 = (): boolean => {
    if (isRetailer) {
      return false;
    }
    return (
      !!issueL2 &&
      issueL1 === brandNodes.L1.GeneralShipping &&
      issueL2 !== brandNodes.L2.Other &&
      issueL2 !== brandNodes.L2.SellingInternational
    );
  };

  const handleSelectL1 = (option: IOption) => {
    setLoggedOutContactUsContextStore({
      issueL1: option.value,
      issueL2: "",
      issueL3: "",
    });
  };

  const handleSelectL2 = (option: IOption) => {
    setLoggedOutContactUsContextStore({
      issueL2: option.value,
      issueL3: "",
    });
  };

  const handleSelectL3 = (option: IOption) => {
    setLoggedOutContactUsContextStore({
      issueL3: option.value,
    });
  };

  return {
    issueL1,
    issueL2,
    issueL3,
    issuesFromL1,
    issuesFromL2,
    issuesFromL3,
    showDropdownL2,
    showDropdownL3,
    showGoToOrderPageCopy,
    handleSelectL1,
    handleSelectL2,
    handleSelectL3,
    handleUserDropdown,
  };
};
